<template>
    <div
        v-if="showDialog"
        class="dialog-mask">
        <div class="add-user-area">
            <div class="add-user-title">
                {{ title }}
            </div>
            <a-input-group size="large">
                <div class="input-line">
                    <a-input
                        v-model="info"
                        :type="inputType"
                        :placeholder="hint" />
                </div>
            </a-input-group>
            <div
                class="message"
                v-if="showError">
                {{ showMessage }}
            </div>
            <div class="submit-button-area">
                <a-button
                    v-on:click="addCancel"
                    class="submit-button"
                    size="large">
                    取消
                </a-button>
                <a-button
                    v-on:click="addConfirm"
                    class="submit-button"
                    size="large"
                    type="primary">
                    修改
                </a-button>
            </div>
            <a-icon
                v-on:click="addCancel"
                class="close-button"
                type="close" />
        </div>
    </div>
</template>
<script>
 import Vue from 'vue';

 import { isEmptyOrWhitespace } from "../util/utils.js"
 import message from "ant-design-vue/lib/message";

 import InputGroup from "ant-design-vue/lib/input/Group";
 import Input from "ant-design-vue/lib/input/Input";

 Vue.component(InputGroup.name, InputGroup);
 Vue.component(Input.name, Input);

 export default {
     name: 'TesterEditDialog',
     data() {
         return {
             showDialog: false,
             showError: false,
             editInfoError: false,
             showMessage: "",
             info: "",
         }
     },
     components: {
     },
     props: {
         title: String,
         hint: String,
         type: String,
         inputType: String,
         successMessage: String,
         userId: Number,
         updateInfoCallback: Function
     },
     computed: {
     },
     methods: {
         show() {
             this.init()
             this.showDialog = true
         },
         init() {
             this.showError = false
             this.showMessage = ""
             this.info = ""
         },
         addCancel() {
             this.showDialog = false
         },
         addConfirm() {
             if (this.confirmInput()) {
                 var that = this
                 this.updateInfo(
                     function() {
                         that.showDialog = false

                         message.success(that.successMessage)
                     },
                     function(errorCode) {
                         that.showError = true
                         that.showMessage = "错误码：" + errorCode
                     }
                 )
             }
         },
         confirmInput() {
             if (isEmptyOrWhitespace(this.info)) {
                 this.showError = true
                 this.showMessage = this.hint
                 return false
             } else {
                 this.showError = false
                 this.showMessage = ""
                 return true
             }
         },
         updateInfo(successCallback, failedCallback) {
             this.editInfoError = false

             var url = process.env.VUE_APP_API_SERVER + '/factory/user/' + this.userId
             var accessToken = localStorage.getItem('accessToken')

             var data = {}

             if (this.type == "displayName") {
                 data = {
                     DisplayName: this.info
                 }
             } else if (this.type == "userName") {
                 data = {
                     Username: this.info
                 }
             }

             var that = this
             fetch(url, {
                 method: "PUT",
                 body: JSON.stringify(data),
                 headers: new Headers({
                     'Content-Type': 'application/json',
                     'Access-Token': accessToken
                 })
             }).then(res => {
                 if (!res.ok) { throw res }
                 return res.json()
             }).catch(error => {
                 that.editInfoError = true

                 failedCallback(error.status)
             }).then(response => {
                 console.log(response)

                 if (!that.editInfoError) {
                     successCallback()

                     that.updateInfoCallback(that.type, that.info)
                 } else {
                     that.editInfoError = false
                 }
             })
         }
     },
 }
</script>

<style scoped>
 .dialog-mask {
     position: absolute;
     top: 0;
     bottom: 0;
     left: 0;
     right: 0;
     background-color: rgba(0, 0, 0, 0.8);
     display: flex;
     flex-direction: column;
     align-items: center;
     justify-content: center;
     z-index: 1000;
 }
 .add-user-area {
     padding: 30px;
     background-color: #FFF;
     border: 1px solid #DDD;
     border-radius: 5px;
     box-shadow: 0px -5px 10px -10px #858484;
     width: 450px;
     height: 280px;
     position: absolute;
     display: flex;
     flex-direction: column;
     align-items: center;
 }
 .add-user-title {
     font-size: 24px;
     margin-bottom: 40px;
 }
 .submit-button-area {
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     align-items: center;
 }
 .submit-button {
     width: 150px;
     margin-left: 10px;
     margin-right: 10px;
 }
 .input-area {
     width: 100%;
 }
 .input-line {
     display: flex;
     flex-direction: row;
     align-items: center;
     margin-top: 10px;
     margin-left: 20px;
     margin-right: 20px;
 }
 .input-label {
     width: 120px;
     font-size: 16px;
     margin-right: 10px;
     text-align: start;
 }
 .close-button {
     position: absolute;
     top: 10px;
     right: 10px;
     cursor: pointer;
     color: #AAA;
 }
 .close-button:hover {
     color: #666;
 }
 .message {
     margin-top: 10px;
     color: #D80E3B;
     font-size: 14px;
 }
</style>
